import SendPanel from './SendPanel'

export default SendPanel
